import React from 'react';

import { ManageOrders } from 'features/orders';

export const OperatorPayinOrdersPage: React.FC = () => <ManageOrders />;
